import React, { useEffect, useState, useRef } from "react";
import ReactSelect, { components } from "react-select";
import AsyncSelect from "react-select/async";

const customStylesnewnew = {
  option: (provided, state) => ({
    ...provided,
    wordBreak: "break-all",
  }),
  control: (styles, state) => {
    return {
      ...styles,
      fontSize: "12px",
      textAlign: "left",
      boxShadow: "none",
      height: state.selectProps?.className === "isLarge" && 100,
      overflowY: "auto",
    };
  },
  menu: () => {
    return {
      // boxShadow: "none",
      marginTop: "10px",
    };
  },
  menuList: (style) => {
    return {
      ...style,
      padding: 0,
      // maxHeight: props.className === "children" ? 180 : 300,
    };
  },

  option: (base, { isSelected }) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    color: isSelected ? "black" : "black",
    backgroundColor: isSelected ? "white" : "white",
    padding: "3px 10px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#d9f6fd",
    color: "black",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "black",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "white",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#0056b3",
      color: "white",
    },
  }),
};

const ReactSelectNew = ({
  statusChangehandler,
  field,
  options,
  serverSearch = false,
  data,
  open = true,
  isAsync = false,
  getPeoplesCall,
  apiUrl = null,
  type = null,
  apiData = null,
  isKanban,
}) => {
  console.log(data, options, 34875687362842);
  const [filterSearchVal, setFilterSearchVal] = useState("");
  const [dataNew, setDataNew] = useState({});

  useEffect(() => {
    if (serverSearch) {
    getPeoplesCall("", apiUrl, type, field)
    }
  }, []);
  

  const MultiValue = (props) => {
    return (
      <components.MultiValue {...props}>
        <span>{props.data.label}</span>
      </components.MultiValue>
    );
  };

  const SingleValue = ({ data }) => {
    return (
      <div>{data.value === "selectAll" ? "All Selected" : data.label}</div>
    );
  };

  const CustomMenuList = (values, options, field) => {
    return (props) => {
      const isAllSelected = values.length === options.length;

      return (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #ccc",
              background: "#f9f9f9",
            }}
          >
            <input
              type="checkbox"
              className="form-check-input"
              checked={isAllSelected}
              disabled={filterSearchVal}
              onChange={() => {
                const updatedValues = !isAllSelected
                  ? options.map((item) => item.value) // Select all
                  : []; // Deselect all

                // Update the state
                setDataNew((state) => ({
                  ...state,
                  [field]: updatedValues,
                }));

                // Call the handler to trigger the API
                if (isKanban) {
                  return statusChangehandler(field)(updatedValues);
                } else {
                  return statusChangehandler(
                    updatedValues.map((val) => ({
                      label: options.find((opt) => opt.value === val)?.label,
                      value: val,
                    })),
                    field
                  );
                }
              }}
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            <label style={{ margin: 0, cursor: "pointer" }}>Select All</label>
          </div>
          <components.MenuList {...props} />
        </div>
      );
    };
  };

  const returnCustomOptions = (values, options) => {
    console.log(values, 784568682346382);
    return (props) => {
      const { data } = props;
      console.log(data, 874578234453454);
      const isChecked =
        data.value === "selectAll"
          ? values.length === options.length
          : values.some((opt) => opt.value === data.value);

      return (
        <components.Option {...props} style={{ padding: "0 5px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              className="form-check-input"
              checked={isChecked}
              readOnly
              style={{ marginRight: 3, cursor: "pointer" }}
            />{" "}
            {data?.profile_image ? (
              <img
                src={data?.profile_image}
                width={20}
                height={20}
                className="assignToImageClass"
              />
            ) : (
              ""
            )}
            <span style={{ marginLeft: 5 }}>{data.label}</span>
          </div>
        </components.Option>
      );
    };
  };

  if (!data || !field) {
    console.error("Invalid data or field:", { data, field });
  }

  const safeDataField = Array.isArray(data?.[field] || dataNew[field])
    ? data[field] || dataNew[field]
    : data && data[field] ? data[field]:[];
  console.log(safeDataField, field, 78578262346);
  if (type) {
    console.log(options, 224324234623874);
  }
  const values = (options || [])
    ?.filter((it) => Array.isArray(safeDataField) ? safeDataField.includes(it._id || it.id || it?.value) : safeDataField === (it._id || it.id || it?.value))
    .map((item) => ({
      label: item?.name || item?.label || item?.option_name || item?.value,
      value: item._id || item.id || item?.value,
    }));

  console.log(options, field, type, apiData, 3424576473288);
  const componentOptions = (options || []).map((it) => ({
    label: it?.name || it?.label || it?.value || it?.option_name,
    value: it?._id || it?.id || it?.value,
    profile_image: it?.profile_image,
  }));

  const debounceRef = useRef(null);

  const loadOptions = (inputValue) => {
    if (type) {
      if (serverSearch) {
        return new Promise((resolve, reject) => {
          if (debounceRef.current) clearTimeout(debounceRef.current);
    
          debounceRef.current = setTimeout(() => {
            const call = type
              ? getPeoplesCall(inputValue, apiUrl, type, field)
              : getPeoplesCall(inputValue, apiUrl);
    
            call.then(resolve).catch(reject);
          }, 1000); // debounce 1s
        });
      }
      return getPeoplesCall(inputValue, apiUrl, type, field);
    } else {
      return getPeoplesCall(inputValue, apiUrl);
    }

  
  };

  if (isAsync &&  serverSearch) {

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={componentOptions}
        loadOptions={loadOptions}
        hideSelectedOptions={false}
        isClearable
        components={{
          MultiValue,
          SingleValue,
          Option: returnCustomOptions(values, componentOptions),
          MenuList: CustomMenuList(values, componentOptions, field),
        }}
        styles={customStylesnewnew}
        isMulti={true}
        className={values?.length > 5 ? "isLarge" : ""}
        {...(open && { menuIsOpen: true })}
        isSearchable={true}
        value={values || ""}
        onChange={(evt) => statusChangehandler(evt, field)}
      />
    );
  }

  if (isAsync) {

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        hideSelectedOptions={false}
        isClearable
        components={{
          MultiValue,
          SingleValue,
          Option: returnCustomOptions(values, componentOptions),
          MenuList: CustomMenuList(values, componentOptions, field),
        }}
        styles={customStylesnewnew}
        isMulti={true}
        className={values?.length > 5 ? "isLarge" : ""}
        {...(open && { menuIsOpen: true })}
        isSearchable={true}
        value={values || ""}
        onChange={(evt) => statusChangehandler(evt, field)}
      />
    );
  }

  return (
    <div className="filterdiv_parent">
      <ReactSelect
        styles={customStylesnewnew}
        isMulti={true}
        className={values?.length > 5 ? "isLarge" : ""}
        {...(open && { menuIsOpen: true })}
        isSearchable={true}
        value={values || ""}
        onChange={(evt) => {
          if (isKanban) {
            if (
              statusChangehandler &&
              typeof statusChangehandler === "function"
            ) {
              const value = Array.isArray(evt)
                ? evt.map((option) => option.value) // Extract values for multi-select
                : evt?.value; // Single select value
              statusChangehandler(field)(value); // Call formChangeHandler(field)(value)
            }
          } else {
            return statusChangehandler(evt, field);
          }
        }}
        options={componentOptions}
        hideSelectedOptions={false}
        components={{
          MultiValue,
          SingleValue,
          Option: returnCustomOptions(values, componentOptions),
          MenuList: CustomMenuList(values, componentOptions, field),
        }}
        onInputChange={(e) => setFilterSearchVal(e)}
      />
    </div>
  );
};

export default React.memo(ReactSelectNew);
